import { XIcon } from 'lucide-react'
import { FunctionComponent } from 'react'

interface Props {
  ariaLabel?: string
}

const Close: FunctionComponent<Props> = ({ ariaLabel = 'Close' }) => {
  return <XIcon className='size-3' aria-label={ariaLabel} />
}

export { Close }
